<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <div class="row pb-2 pt-1 bordered-radius">
      <div class="col-12 col-sm-6 col-md-4 pt-2">
        <ValidationProvider
          v-slot="{ errors }"
          name="Categoría"
          rules="required"
        >
          <CustomDropDown
            v-model="model.category"
            :options="collections.categories"
            :error="errors[0]"
            :disabled="!saloon"
            custom-error-msg="La categoría es requerida."
            placeholder="Seleccione"
            fieldkey="id"
            fieldname="name"
            label="Categoría:"
            @input="onChangeCategory"
          />
          <label v-if="!errors[0]" class="data-name mt-2 ml-1">
            <em class="far fa-exclamation-circle text-warning mr-1" />
            Puede seleccionar más de un (1) artículo.
          </label>
        </ValidationProvider>
      </div>
      <div class="col-12 col-sm-6 col-md-4 pt-2">
        <ValidationProvider
          v-slot="{ errors }"
          name="Lista de Artículos"
          rules="required"
        >
          <CustomDropDown
            v-model="model.article"
            :options="articleList"
            :error="errors[0]"
            :disabled="!model.category"
            custom-error-msg="El artículo es requerido."
            placeholder="Seleccione"
            fieldkey="id"
            fieldname="name"
            label="Lista de Artículos:"
          />
        </ValidationProvider>
      </div>
      <div
        class="col-12 pt-2 pt-md-0 col-md-2 d-flex align-self-center justify-content-end"
      >
        <ActionButton
          variant="success m-1"
          :i="`fas fa-${editting ? 'save' : 'file-plus'}`"
          :responsive="true"
          @click="handleSubmit(submit)"
        >
          {{ editting ? 'Guardar' : 'Añadir' }}
        </ActionButton>
      </div>
      <div
        class="col-12 pt-2 pt-md-0 col-md-2 d-flex align-self-center justify-content-end"
      >
        <ActionButton
          class="max-width-sm"
          variant="outline-danger m-1"
          i="fas fa-times-circle"
          text="Cancelar"
          :responsive="true"
          @click="$emit('close')"
        />
      </div>
      <div class="col-12 pt-2">
        <div class="border-divider" />
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import codeService from '@/modules/common/code.api';

const modelInitialState = (defaults) => ({
  id: 0,
  category: null,
  article: null,
  quantity: null,
  ...defaults,
});

export default {
  name: 'RequesterForm',
  components: {
    ActionButton,
    CustomDropDown,
  },
  props: {
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    saloon: { type: Object, default: () => {} },
    articlesToExclude: { type: Array, default: () => [] },
  },
  data: () => ({
    model: modelInitialState(),
    collections: { categories: [], articles: [] },
  }),
  computed: {
    articleList() {
      return this.collections.articles.filter(
        (article) =>
          !this.articlesToExclude.some((articleId) => article.id == articleId)
      );
    },
  },
  methods: {
    submit() {
      this.$emit('submit', this.model, this.newForm);
    },
    newForm() {
      this.model = modelInitialState({ category: this.model.category });
      this.resetForm();
    },
    resetForm() {
      this.$refs.form.reset && this.$refs.form.reset();
    },
    async onChangeCategory(category) {
      this.model.article = null;
      this.collections.articles = [];
      this.resetForm();
      if (category) {
        await this.fetchArticles(category.id);
      }
    },
    async fetchCategories() {
      const { data: categories } = await codeService.getMaterialCategoryTypes();
      this.collections.categories = categories;
    },
    async fetchArticles(categoryId) {
      const { data: articles } = await codeService.getMaterialItemTypes(
        this.saloon.id,
        categoryId
      );
      this.collections.articles = articles;
    },
  },
  created() {
    this.fetchCategories();
    if (this.item) {
      this.model = { ...this.model, ...this.item };
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.bordered-radius {
  border-radius: 5px 5px 0px 0px;
}
.border-divider {
  content: '';
  width: 100%;
  border-bottom: 2px solid $gray_5;
}
</style>
